// UMD 入口（<script> 引入场景）
// rollup 构建此文件为 dist/umd/jx-bridge.core.js，运行时动态加载 adapter js
// 此入口仅引用 loader-script，rollup 不会看到 import() 调用，从而不会把 adapter 打进核心包
// 库加载即执行 token 统一逻辑（副作用模块，需在 runtime 之前执行）
import './token-unify.js';

import { createJXBridge } from './runtime.js';
import { loadAdapter } from './loader-script.js';

export default createJXBridge({ loadAdapter });
